let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("atp96")).then(() => parcelRequire('52WYW'));